import { subscribeDataChanging, unsubscribeDataChanging } from './index'

export default {
  beforeCreate () {
    subscribeDataChanging(this)
    this._subscribing = true
  },

  beforeDestroy () {
    if (this._subscribing) {
      unsubscribeDataChanging(this)
      delete this._subscribing
    }
  }
}



// WEBPACK FOOTER //
// ./packages/helper/i18n/mixin.js